import { FC } from 'react'

import { Container } from 'components/container'
import { FollowUs, StyledFooter, Title } from './styled'
import { IconFacebook } from 'components/icons/facebook'
import { IconInstagram } from 'components/icons/instagram'
import { IconYoutube } from 'components/icons/youtube'
import { useDataContext } from 'context/data-context'

export const Footer: FC = () => {
  const { strings } = useDataContext()

  return (
    <StyledFooter>
      <Container $fluid>
        <div data-about>
          <Title>О ТЕЛЕКАНАЛЕ “НАСТОЯЩЕЕ ВРЕМЯ”</Title>
          <p>
            Мы – <a href="https://www.currenttime.tv/about">телеканал "Настоящее Время"</a>. Мы делаем яркие видео, рассказываем о важных новостях и злободневных темах. Наша миссия – продвигать демократические ценности и институты, а также права человека, предоставляя аудитории то, что не всегда могут обеспечить местные СМИ
          </p>
        </div>
        <div data-authors>
          <Title>АВТОРЫ ПРОЕКТА</Title>
          <p>{strings.about_the_authors}</p>
        </div>
        <div data-social>
          <Title>Подпишись</Title>
          <FollowUs>
            <li>
              <a href="https://www.facebook.com/currenttimedoc" target="_blank">
                <IconFacebook />
              </a>
            </li>
            <li>
              <a href="https://instagram.com/currenttimedoc" target="_blank">
                <IconInstagram />
              </a>
            </li>
            <li>
              <a
                href="https://www.youtube.com/c/CurrentTimeDoc"
                target="_blank"
              >
                <IconYoutube />
              </a>
            </li>
          </FollowUs>
        </div>
        <div data-copy>
          <p>© Настоящее Время. Все права защищены</p>
        </div>
      </Container>
    </StyledFooter>
  )
}
